<template>
  <div class="history-content">
    <v-switch
      color="green"
      v-model="player_switches.country_filter"
      label="Filtern nach Wohnsitz (Land)"
    ></v-switch>
    <div v-if="player_switches.country_filter">
      <label>Land</label>
      <v-autocomplete
        color="green"
        :items="$store.state.countries"
        v-model="user_data.player_country"
        solo
      ></v-autocomplete>
    </div>
    <v-switch
      color="green"
      v-model="player_switches.region_filter"
      label="Filtern nach Region/Verband"
    ></v-switch>
    <div v-if="player_switches.region_filter">
      <label>Region/Verband</label>
      <v-select
        color="green"
        :items="$store.state.verband"
        v-model="user_data.player_verband"
        solo
      ></v-select>
      <div v-if="user_data.player_verband">
        <label>Liga</label>
        <v-select
          solo
          color="green"
          :items="$store.state.filter_leagues[user_data.player_verband]"
          item-text="league"
          item-value="category"
          v-model="user_data.player_category"
          multiple
        ></v-select>
      </div>
    </div>
    <v-switch
      color="green"
      v-model="player_switches.sex_filter"
      label="Filtern nach Geschlecht"
    ></v-switch>
    <div v-if="player_switches.sex_filter">
      <label for>Geschlecht</label>
      <v-select
        solo
        color="green"
        :items="$store.state.sex"
        v-model="user_data.player_sex"
        multiple
      ></v-select>
    </div>

    <v-switch
      color="green"
      v-model="player_switches.position_filter"
      label="Filtern nach Position"
    ></v-switch>
    <div v-if="player_switches.position_filter">
      <label for>Position</label>
      <v-select
        solo
        color="green"
        :items="$store.state.positions_extended"
        v-model="user_data.player_positions"
        multiple
      ></v-select>
    </div>

    <v-switch
      color="green"
      v-model="player_switches.foot_filter"
      label="Filtern nach bev. Fuß"
    ></v-switch>
    <div v-if="player_switches.foot_filter">
      <label for>Bevorzugter Fuß</label>
      <v-select
        solo
        color="green"
        :items="$store.state.playerFoot"
        v-model="user_data.player_foot"
        multiple
      ></v-select>
    </div>

    <v-switch
      color="green"
      v-model="player_switches.language_filter"
      label="Filtern nach Sprache"
    ></v-switch>
    <div v-if="player_switches.language_filter">
      <label for>Sprache</label>
      <v-select
        solo
        color="green"
        :items="$store.state.languages"
        v-model="user_data.player_languages"
        multiple
      ></v-select>
    </div>
    <v-switch
      color="green"
      v-model="player_switches.age_filter"
      label="Filtern nach Alter"
    ></v-switch>
    <div v-if="player_switches.age_filter">
      <label>Alter</label>
      <v-range-slider
        class="age-slider"
        solo
        color="green"
        thumb-label="always"
        :min="14"
        :max="40"
        @end="changeSlider"
      ></v-range-slider>
    </div>
    <v-switch
      color="green"
      v-model="player_switches.no_team"
      label="Filtern nach Vereinslos"
    ></v-switch>
    <v-btn
      flat
      @click="resetFilters('player_switches')"
      class="reset-filter-button button-small"
    >
      <v-icon class="mr-2">undo</v-icon> Alle Filter zurücksetzen
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'player-filter',

  props: {
    player_switches: {
      type: Object,
      default: () => {},
    },
    user_data: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    changeSlider(value) {
      this.user_data.player_age_range = value;
      this.user_data.playerAgeRange = this.user_data.player_age_range;
      this.player_switches.age_filter = false;
      this.player_switches.age_filter = true;
    },

    resetFilters(type) {
      console.log('resetfilters', type);
      this.$emit('reset-filters', type);
    },
  },
};
</script>
